import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { UserEntity } from "../user/user.entity";
import { EventsEntity } from "./event.entity";

@Entity('event_files')
export class EventFilesEntity {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("int",{
    nullable:false,
    name:"event_id"
  })
  eventId:number;
  @Column("int",{
    nullable:false,
    name:"user_id"
  })
  userId:number;
  @Column("varchar",{
    nullable: false,
    length:500,
    name:"file_type"
  })
  fileType:string;
  @Column("varchar",{
    nullable: false,
    length:500,
    name:"file_url"
  })
  fileUrl:string;
  
  @ManyToOne(() => EventsEntity, (event: EventsEntity) => event.eventfiles)
  @JoinColumn({ name: 'event_id' })
  event: EventsEntity;
  @ManyToOne(() => UserEntity, (user: UserEntity) => user.eventfiles)
  @JoinColumn({name: 'user_id'})
  user: UserEntity;
}